__turbopack_context__.v({
  "className": "instrument_serif_895575f8-module__kto4Qa__className",
});
